import React from "react";
import { Box, Card, CardContent, CardHeader, Chip, Divider, Stack, Typography } from "@mui/material";

export default function AssignmentsCard({ assignments }) {
    return (
        <Card variant="outlined" sx={{ minHeight: { xs: "auto", md: 420 }, display: "flex", flexDirection: "column", minWidth: 0 }}>
            <CardHeader title="Assignments" />
            <Divider />
            <CardContent sx={{ flex: 1, overflow: "auto" }}>
                {assignments.length === 0 ? (
                    <Typography variant="body2" color="text.secondary">No assignments for this classroom.</Typography>
                ) : (
                    <Stack spacing={2}>
                        {assignments.map((assignment) => (
                            <Box key={assignment.id} sx={{ pb: 1, borderBottom: "1px solid", borderColor: "divider" }}>
                                <Typography sx={{ fontWeight: 600 }}>{assignment.name || `Assignment #${assignment.id}`}</Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                                    {assignment.description || "—"}
                                </Typography>
                                <Box sx={{ mt: 1 }}>
                                    <Chip size="small" color="success" variant="outlined" label={`Max score: ${assignment.max_value ?? 0}`} />
                                </Box>
                            </Box>
                        ))}
                    </Stack>
                )}
            </CardContent>
        </Card>
    );
}

